module.exports = __webpack_public_path__ + "static/media/help_Contable.638e0647.png";